import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setWoundMeasurementData, setDetailAssessment, detailAssessmentAsync, setAssessmentNotes } from '../app/patientSlice';
import { AssessmentDetail } from '../components/core/Patients/assessmentDetail';

export const Assessment = () => {
  const dispatch = useDispatch();
  const { assessmentId, patientId } = useParams();

  useEffect(() => {
      const payload = {patientId, assessmentId}
      dispatch(setAssessmentNotes(null));
      dispatch(setWoundMeasurementData(null));
      dispatch(setDetailAssessment(null));
      dispatch(detailAssessmentAsync(payload))
    }, [dispatch, patientId, assessmentId])

  return <AssessmentDetail />;
};
